// THIS FILE IS AUTOGENERATED. DO NOT EDIT
/* eslint-disable */
/* tslint:disable */
import * as theme from './theme'
export { theme }